import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiUrl } from '../constants/apiUrl';
import { Period } from '../models/entities/period';
import { ListResponseModel } from '../models/responseModels/list-response-model';

@Injectable({
  providedIn: 'root'
})
export class PeriodService {

  constructor(private httpClient: HttpClient) { }

  getList(): Observable<ListResponseModel<Period>> {
    return this.httpClient.get<ListResponseModel<Period>>(ApiUrl.url + "Period/getList");
  }

}
